export const locationImage = (placeId: string) => ['location-image', placeId] as const

export const locationDrawImages = (
  category: string,
  title: string,
  description?: string,
  emoji?: string,
  placeSearch?: string,
) => ['location-draw-images', category, title, description, emoji, placeSearch] as const
